module.exports = __webpack_public_path__ + "static/img/extend_01.3dff2d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/extend_01.jpg
// module id = UK4T
// module chunks = 1